import { useOutletContext } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '@aws-amplify/ui-react/styles.css';
import Cards from 'components/Cards/Card';
import {
  Cockpit_data_admin,
  Cockpit_data_gestor,
  Cockpit_data_editor,
} from './Cockpit_data';

import './Cockpit.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Contacts() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState();
  const [userProfile, setUserProfile] = useState();
  const [auth] = useOutletContext();

  useEffect(() => {
    setUserName(auth.getIdToken().payload.name);
    setUserProfile(auth.getIdToken().payload['custom:user_profile']);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const navigatePage = (route) => {
  //   navigate(`/${route}`);
  // };

  return (
    <Container id="home">
      <div className="name_user">
        <div className="user_line">
          <span className="name_user_title">Bem-vindo(a) {userName}</span>
        </div>
      </div>
      <Col>
        <Row className="cockpit_row_content">
          {(userProfile === 'ADMIN' &&
            Cockpit_data_admin.map(item => (
              <Cards
                key={item.id}
                title={item.title}
                description={item.description}
                image={item.image_link}
                link={() => navigate(item.link_to)}
                className="cockpit_card"
              />
            ))) ||
            (userProfile === 'MANAGER' &&
              Cockpit_data_gestor.map(item => (
                <Cards
                  key={item.id}
                  title={item.title}
                  description={item.description}
                  image={item.image_link}
                  link={() => navigate(item.link_to)}
                />
              ))) ||
            (userProfile === 'EDITOR' &&
              Cockpit_data_editor.map(item => (
                <Cards
                  key={item.id}
                  title={item.title}
                  description={item.description}
                  image={item.image_link}
                  link={() => navigate(item.link_to)}
                />
              )))}
        </Row>
      </Col>
      {/* <Col>
        <Row className="cockpit_row_content">
          {(userProfile === "EDITOR" || userProfile === "ADMIN" || userProfile === "MANAGER") && (
            <div className="cockpit_card cockpit_card_space" onClick={() => navigatePage("videos")}>
              <div className="card_cockpit_image">
                <img src="/img/navbar_cockpit/videos_icon.svg" alt="Logo" style={{ width: "66px", height: "58px" }} />
              </div>
              <div className="card_cockpit_title">
                <p className="card_cockpit_title_p">Vídeos</p>
              </div>
              <div className="card_cockpit_text">
                <p className="card_cockpit_text_p">Importação de vídeos, adição de informações descritivas e gestão.</p>
              </div>
            </div>
          )}
          {(userProfile === "EDITOR" || userProfile === "ADMIN" || userProfile === "MANAGER") && (
            <div className="cockpit_card cockpit_card_space" onClick={() => navigatePage("colecoes")}>
              <div className="card_cockpit_image">
                <img src="/img/navbar_cockpit/colecoes_icon.svg" alt="Logo" style={{ width: "77px", height: "64px" }} />
              </div>
              <div className="card_cockpit_title">
                <p className="card_cockpit_title_p">Coleções</p>
              </div>
              <div className="card_cockpit_text">
                <p className="card_cockpit_text_p">Importação de vídeos agrupados, adição de informações descritivas e gestão.</p>
              </div>
            </div>
          )}

          {(userProfile === "ADMIN" || userProfile === "MANAGER") && (
            <div className="cockpit_card cockpit_card_space" onClick={() => navigatePage("usuarios")}>
              <div className="card_cockpit_image">
                <img src="/img/navbar_cockpit/gestao_usuarios_icon.svg" alt="Logo" style={{ width: "92px", height: "74px" }} />
              </div>
              <div className="card_cockpit_title">
                <p className="card_cockpit_title_p">Gestão de usuários</p>
              </div>
              <div className="card_cockpit_text">
                <p className="card_cockpit_text_p">Cadastro e gestão de usuários com atribuição de perfil com associação de unidades e canais.</p>
              </div>
            </div>
          )}

          {userProfile === "ADMIN" && (
            <div className="cockpit_card" onClick={() => navigatePage("aplicativo")}>
              <div className="card_cockpit_image">
                <img src="/img/navbar_cockpit/home_app_icon.svg" alt="Logo" style={{ width: "55px", height: "80px" }} />
              </div>
              <div className="card_cockpit_title">
                <p className="card_cockpit_title_p">Home do App</p>
              </div>
              <div className="card_cockpit_text">
                <p className="card_cockpit_text_p">Configuração dos vídeos e coleções destacados na home do app.</p>
              </div>
            </div>
          )}
        </Row>
        {userProfile === "ADMIN" && (
          <Row className="cockpit_row_content">
            <div className="cockpit_card cockpit_card_space" onClick={() => navigatePage("unidades")}>
              <div className="card_cockpit_image">
                <img src="/img/navbar_cockpit/unidades_sesc_icon.svg" alt="Logo" style={{ width: "80px", height: "80px" }} />
              </div>
              <div className="card_cockpit_title">
                <p className="card_cockpit_title_p">Unidades</p>
              </div>
              <div className="card_cockpit_text">
                <p className="card_cockpit_text_p">Gestão de unidades Sesc.</p>
              </div>
            </div>

            <div className="cockpit_card cockpit_card_space" onClick={() => navigatePage("canais")}>
              <div className="card_cockpit_image">
                <img src="/img/navbar_cockpit/canais_sesc_icon.svg" alt="Logo" style={{ width: "67px", height: "75px" }} />
              </div>
              <div className="card_cockpit_title">
                <p className="card_cockpit_title_p">Canais</p>
              </div>
              <div className="card_cockpit_text">
                <p className="card_cockpit_text_p">Gestão de canais Sesc.</p>
              </div>
            </div>

            <div className="cockpit_card cockpit_card_space" onClick={() => navigatePage("personalidades")}>
              <div className="card_cockpit_image">
                <img src="/img/navbar_cockpit/personalidade_icon.svg" alt="Logo" style={{ width: "65px", height: "74px" }} />
              </div>
              <div className="card_cockpit_title">
                <p className="card_cockpit_title_p">Personalidades</p>
              </div>
              <div className="card_cockpit_text">
                <p className="card_cockpit_text_p">Gestão de personalidades associadas as mídias.</p>
              </div>
            </div>

            <div className="cockpit_card" onClick={() => navigatePage("palavras_chave")}>
              <div className="card_cockpit_image">
                <img src="/img/navbar_cockpit/palavras_chave_icon.svg" alt="Logo" style={{ width: "69px", height: "58px" }} />
              </div>
              <div className="card_cockpit_title">
                <p className="card_cockpit_title_p">Palavras-chave</p>
              </div>
              <div className="card_cockpit_text">
                <p className="card_cockpit_text_p">Gestão de palavras-chave associadas as mídias.</p>
              </div>
            </div>
          </Row>
        )}
      </Col>

      <Row>
        <Col></Col>
      </Row> */}
    </Container>
  );
}

export default Contacts;
